<a
  class="text-sm font-semibold"
  [class.text-ui-gray-100]="!link()"
  [queryParams]="queryParams()"
  [queryParamsHandling]="queryParamsHandling()"
  [routerLink]="link()"
>
  <ng-content />
</a>
